import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service'; // Ajusta la ruta a tu NotificationService
import { AuthService } from '../services/AuthService';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(private notificationService: NotificationService ,
    private authService: AuthService
  ) {} // Inyecta NotificationService aquí

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {

         // 👇 Si el backend devolvió error pero la request era blob (zip),
  // Angular lo entrega como Blob.
  if (error.error instanceof Blob) {
    return new Observable<HttpEvent<unknown>>((observer) => {
      const reader = new FileReader();

      reader.onload = () => {
        const text = String(reader.result ?? '');

        // Intenta parsear JSON típico de NestJS:
        // { statusCode: 400, message: "...", error: "Bad Request" }
        let msg = 'Ha ocurrido un error inesperado.';
        try {
          const json = JSON.parse(text);

          // Nest puede devolver message string o array (validation)
          const m = json?.message;
          msg = Array.isArray(m) ? m.join('\n') : (m ?? text ?? msg);
        } catch {
          // Si no es JSON, usa el texto tal cual
          msg = text || msg;
        }

        this.notificationService.showWarning(msg, 'Solicitud Incorrecta');

        observer.error(error);
      };

      reader.onerror = () => {
        this.notificationService.showError(
          'Error inesperado al leer la respuesta del servidor.',
          'Error'
        );
        observer.error(error);
      };

      reader.readAsText(error.error);
    });
  }


        let errorMessage = 'Ha ocurrido un error inesperado.';
        let errorTitle = 'Error';

        // Error del lado del cliente o de red
        if (error.error instanceof ErrorEvent) {
          errorMessage = `Error de red o cliente: ${error.error.message}`;
          errorTitle = 'Error de Conexión';
          this.notificationService.showError(errorMessage, errorTitle);
        } else {
          // El backend retornó un código de respuesta fallido (ej. 4xx, 5xx)
          // El cuerpo de la respuesta puede contener pistas sobre lo que salió mal.
          let url = error.url || '';
          switch (error.status) {
            case 0: // Error de conexión o servidor no responde
              errorMessage = 'No se pudo conectar al servidor. Verifique su conexión a Internet o el estado del servidor.';
              errorTitle = 'Servidor No Disponible';
              this.notificationService.showError(errorMessage, errorTitle);
              break;
            case 400: // Bad Request              
              errorMessage = `Solicitud inválida: ${error.error?.message || error.statusText || error.message || 'Datos incorrectos enviados.'}`;
              errorTitle = 'Solicitud Incorrecta';
              this.notificationService.showWarning(errorMessage, errorTitle);
              break;
            case 401: // Unauthorized

           
              // 3) Aquí sí es un 401 real con token presente -> usuario sin permisos / credenciales malas
              errorMessage = 'No autorizado. Por favor, inicie sesión de nuevo.';
              errorTitle = 'Acceso Denegado';
              this.notificationService.showError(errorMessage, errorTitle);
              break;
            case 403: // Forbidden      
            
              // 1) Si es refresh/logout, dejamos que AuthInterceptor se encargue
              if (url.includes('/auth/refresh') || url.includes('/auth/logout')) {
                break; // sin notificación
              }

              // 2) Si YA no hay token, significa que AuthInterceptor limpió sesión
              //    (sesión expirada) -> no mostramos este mensaje genérico
              if (!this.authService.isAuthenticate()) {
                break;
              }
              
              errorMessage = 'Acceso denegado. No tiene permisos para realizar esta acción.';
              errorTitle = 'Permisos Insuficientes H';
              this.notificationService.showError(errorMessage, errorTitle);
              break;
            case 404: // Not Found
              
              // 1) Si es refresh/logout, dejamos que AuthInterceptor se encargue
              if (url.includes('/institution-settings/public')) {
                break; // sin notificación
              }
              errorMessage = error.error.message;
              errorTitle = 'No Encontrado';
              this.notificationService.showWarning(errorMessage, errorTitle);
              break;
            case 409: // Conflict
              errorMessage = `Conflicto: ${error.error?.message || error.statusText || 'El recurso ya existe o hay un conflicto.'}`;
              errorTitle = 'Conflicto de Datos';
              this.notificationService.showWarning(errorMessage, errorTitle);
              break;
            case 500: // Internal Server Error
              errorMessage = `Error interno del servidor (${error.status}). Intente de nuevo más tarde o contacte a soporte.`;
              errorTitle = 'Error del Servidor';
              this.notificationService.showError(errorMessage, errorTitle);
              break;
            default: // Otros errores de servidor o cliente
              errorMessage = `Error (${error.status}): ${error.error?.message || error.message || error.statusText || 'Ha ocurrido un error inesperado.'}`;
              errorTitle = 'Error HTTP';
              this.notificationService.showError(errorMessage, errorTitle);
              break;
          }
        }

        // console.error('Detalle del error interceptado:', error);

        // Es importante re-lanzar el error para que los componentes que usen este servicio
        // puedan manejar errores específicos si lo necesitan
        return throwError(() => error);

      })
    );
  }
}
